import styled from 'styled-components'
import { Icon, Button, Card, Typography } from '@equinor/eds-core-react'

export const HeaderContainer = styled(Card)`
    display: flex;
    max-width: 744px;
    font-size: 18px;
    line-height: 24px;
    padding: 24px;
    padding-bottom: 0px;
    background-color: rgb(245, 245, 245);
    box-shadow: none;

    @media (max-width: 1024px) {
        padding: 10px;
    }
`
export const BackgroundContainer = styled(Card)`
    gap: 24px;
    padding: 3px;
    flex-wrap: wrap;
    background-color: rgb(245, 245, 245);
    box-shadow: none;
    min-height: 100%;

    @media (max-width: 1024px) {
        flex: 1;
        margin-right: 0;
        padding: 0px;
        gap: 0px;
    }
`

export const CardContainer = styled.div`
    display: flex;
    gap: 16px;
    padding: 24px 24px 24px 32px;
    flex-wrap: wrap;
    background-color: rgb(245, 245, 245);

    @media (max-width: 1024px) {
        margin-left: 0px;
        gap: 12px;
        padding: 10px;
        padding-bottom: 6rem;
    }
`

export const SensorCardContainer = styled(Card)<{ $isExpanded?: boolean }>`
    display: flex;
    width: 386px;
    height: ${({ $isExpanded }) => ($isExpanded ? '440px' : '224px')};
    cursor: pointer;
    flex-direction: column;
    padding: 0;
    gap: 0;
    box-shadow: 0px 3px 4px 0px #0000001f;
    box-shadow: 0px 2px 4px 0px #00000024;
    background-color: #ffffff;
    overflow: hidden;

    &:focus-visible {
        outline: 2px solid var(--eds-color-border-focus);
    }

    @media (max-width: 1024px) {
        width: 100%;
        height: ${({ $isExpanded }) => ($isExpanded ? '460px' : '240px')};
    }
`

export const CardBody = styled.div<{ $isExpanded?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 12px;
    background-color: ${({ $isExpanded }) => ($isExpanded ? '#e8f8e9' : '#ffffff')};
    transition: background-color 0.2s ease;

    @media (max-width: 1024px) {
        padding-bottom: 8px;
    }
`

export const CardHeading = styled(Typography)`
    font-family: Equinor;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    color: #3d3d3d;
    text-align: left;
    margin: 0 0 8px 0;
`

export const ContentRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: flex-start;
`

export const CardTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-family: Equinor;
    flex: 1;
    min-width: 0;
`

export const CardImageWrapper = styled.div`
    padding: 0 12px 0 0;
    cursor: pointer;
    flex-shrink: 0;

    img {
        width: 90px;
        height: 90px;
        object-fit: contain;
    }
`

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 12px;
    row-gap: 4px;
    align-items: center;
    font-family: Equinor;
`

export const InfoLabel = styled.span`
    font-family: Equinor;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #6f6f6f;
`

export const InfoValue = styled.span`
    font-family: Equinor;
    font-size: 16px;
    line-height: 20px;
    color: #3d3d3d;
`

export const AtexValue = styled.span`
    font-family: Equinor;
    font-size: 16px;
    line-height: 20px;
    color: #8a4100;
    display: inline-flex;
    align-items: center;
    gap: 4px;
`

export const AtexIcon = styled(Icon)`
    color: #8a4100;
    fill: #8a4100;
`

export const DescriptionPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 12px 12px;
    background-color: #ffffff;
    border-top: 1px solid #d4d4d4;
    flex: 1;
    min-height: 0;
`

export const RangeRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: baseline;
`

export const DescriptionText = styled(Typography)`
    flex: 1;
    color: #3d3d3d;
`

export const ProductButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
`

export const DescriptionButton = styled(Button)<{}>`
    height: 36px;
    width: 152px;
    align-self: flex-end;
    margin-top: 8px;
`
export const HowToSetUpButton = styled(Button)<{}>`
    height: 48px;
    width: 152;
    top: 5px;
    left: 80px;

    @media (max-width: 1024px) {
        left: 45px;
    }
`
export const ProductPageButton = styled(Button)<{}>`
    height: 36px;
    width: 152px;
`
export const OrderButton = styled(Button)<{}>`
    height: 48px;
    width: 152px;
    margin-left: 9px;
    margin-top: auto;
    top: 0px;

    @media (max-width: 1024px) {
        margin-left: -10px;
        top: 10px;
    }
`
export const CardIcon = styled(Icon)<{}>``

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 24px 24px 16px 32px;
    flex-wrap: wrap;

    @media (max-width: 1024px) {
        padding: 10px;
        flex-direction: column;
        align-items: stretch;
    }
`

export const HeaderTextColumn = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 744px;
    flex: 1;
    min-width: 0;
`

export const ToolbarColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    min-width: 320px;

    @media (max-width: 1024px) {
        align-items: stretch;
        min-width: 0;
    }
`

export const ToolbarRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    position: relative;
`

export const MobileFilterBar = styled.div`
    display: none;
    margin: 0 0 1rem 0;

    @media (max-width: 1024px) {
        display: flex;
        position: fixed;
        bottom: 25px;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 32px);
        box-sizing: border-box;
        padding: 8px 8px;
        justify-content: space-between;
        background-color: #ffffff;
        border: 1px solid #d4d4d4;
        border-radius: 8px;
        box-shadow: 0px 2px 4px 0px #00000024;
        z-index: 9;

        button {
            width: 100%;
        }
    }
`

export const MobileToolbar = styled.div`
    padding: 0 10px;
`
